import React from 'react';
import { motion } from 'framer-motion';
import './AnimatedBackground.css';

const AnimatedBackground = () => {
  // Better distribution to avoid overlapping - 10 shapes in grid-like positions
  const shapes = Array.from({ length: 10 }, (_, i) => {
    const row = Math.floor(i / 5);
    const col = i % 5;
    return {
      id: i,
      size: Math.random() * 80 + 60,
      x: (col * 20) + (Math.random() * 15) + 5, // Grid-based with randomness
      y: (row * 40) + (Math.random() * 20) + 10,
      duration: Math.random() * 18 + 12,
      delay: Math.random() * 6,
    };
  });

  return (
    <div className="animated-background">
      {/* Well-distributed floating shapes */}
      {shapes.map((shape) => (
        <motion.div
          key={shape.id}
          className={`floating-shape shape-${shape.id % 4}`}
          style={{
            width: shape.size,
            height: shape.size,
            left: `${shape.x}%`,
            top: `${shape.y}%`,
          }}
          animate={{
            x: [0, 80, -50, 0],
            y: [0, -70, 40, 0],
            rotate: [0, 180, 360],
            scale: [1, 1.2, 0.8, 1],
          }}
          transition={{
            duration: shape.duration,
            repeat: Infinity,
            ease: "easeInOut",
            delay: shape.delay,
          }}
        />
      ))}
      
      {/* Gradient orbs */}
      <motion.div
        className="gradient-orb orb-1"
        animate={{
          x: [0, 150, -80, 0],
          y: [0, -100, 60, 0],
          scale: [1, 1.4, 0.7, 1],
        }}
        transition={{
          duration: 24,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      
      <motion.div
        className="gradient-orb orb-2"
        animate={{
          x: [0, -120, 100, 0],
          y: [0, 80, -50, 0],
          scale: [1, 0.6, 1.5, 1],
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 4,
        }}
      />
      
      <motion.div
        className="gradient-orb orb-3"
        animate={{
          x: [0, 90, -140, 0],
          y: [0, -60, 90, 0],
          scale: [1, 1.1, 0.9, 1],
        }}
        transition={{
          duration: 32,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 8,
        }}
      />
      
      {/* Particle system */}
      <div className="particles">
        {Array.from({ length: 25 }, (_, i) => (
          <motion.div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -80, 0],
              opacity: [0, 1, 0],
            }}
            transition={{
              duration: Math.random() * 3 + 3,
              repeat: Infinity,
              delay: Math.random() * 5,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default AnimatedBackground;
